module.exports = __webpack_public_path__ + "static/action-3pizza-8ec55db9b5dd48388e15cc379ee52e86.png";